import { Link } from 'react-router-dom';
import { Home, Calendar, Users, Settings } from 'lucide-react';

export function MobileFooter() {
  return (
    <footer className="fixed bottom-0 z-50 w-full border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex items-center justify-around py-2">
        <Link
          to="/dashboard"
          className="flex flex-col items-center space-y-1 px-3 py-2 text-xs"
        >
          <Home className="h-5 w-5" />
          <span>Home</span>
        </Link>
        <Link
          to="/games"
          className="flex flex-col items-center space-y-1 px-3 py-2 text-xs"
        >
          <Calendar className="h-5 w-5" />
          <span>Games</span>
        </Link>
        <Link
          to="/teams"
          className="flex flex-col items-center space-y-1 px-3 py-2 text-xs"
        >
          <Users className="h-5 w-5" />
          <span>Teams</span>
        </Link>
        <Link
          to="/settings"
          className="flex flex-col items-center space-y-1 px-3 py-2 text-xs"
        >
          <Settings className="h-5 w-5" />
          <span>Settings</span>
        </Link>
      </div>
    </footer>
  );
}